// Major airports with coordinates for flight path visualization
// Coordinates are [longitude, latitude] for easier SVG plotting
export const AIRPORTS = {
  // United Hubs
  EWR: { name: "Newark Liberty", city: "Newark", coords: [-74.17, 40.69] },
  IAH: { name: "George Bush Intercontinental", city: "Houston", coords: [-95.34, 29.98] },
  ORD: { name: "O'Hare International", city: "Chicago", coords: [-87.90, 41.98] },
  DEN: { name: "Denver International", city: "Denver", coords: [-104.67, 39.86] },
  LAX: { name: "Los Angeles International", city: "Los Angeles", coords: [-118.41, 33.94] },
  SFO: { name: "San Francisco International", city: "San Francisco", coords: [-122.38, 37.62] },
  IAD: { name: "Washington Dulles", city: "Washington D.C.", coords: [-77.46, 38.95] },
  
  // Major US Airports
  JFK: { name: "John F. Kennedy", city: "New York", coords: [-73.78, 40.64] },
  LGA: { name: "LaGuardia", city: "New York", coords: [-73.87, 40.77] },
  ATL: { name: "Hartsfield-Jackson", city: "Atlanta", coords: [-84.43, 33.64] },
  DFW: { name: "Dallas/Fort Worth", city: "Dallas", coords: [-97.04, 32.90] },
  MIA: { name: "Miami International", city: "Miami", coords: [-80.29, 25.79] },
  SEA: { name: "Seattle-Tacoma", city: "Seattle", coords: [-122.31, 47.45] },
  BOS: { name: "Logan International", city: "Boston", coords: [-71.01, 42.36] },
  PHX: { name: "Phoenix Sky Harbor", city: "Phoenix", coords: [-112.01, 33.44] },
  MSP: { name: "Minneapolis-St. Paul", city: "Minneapolis", coords: [-93.22, 44.88] },
  DTW: { name: "Detroit Metro", city: "Detroit", coords: [-83.35, 42.21] },
  PHL: { name: "Philadelphia International", city: "Philadelphia", coords: [-75.24, 39.87] },
  LAS: { name: "Harry Reid International", city: "Las Vegas", coords: [-115.15, 36.08] },
  MCO: { name: "Orlando International", city: "Orlando", coords: [-81.31, 28.43] },
  SAN: { name: "San Diego International", city: "San Diego", coords: [-117.19, 32.73] },
  SLC: { name: "Salt Lake City", city: "Salt Lake City", coords: [-111.98, 40.79] },
  PDX: { name: "Portland International", city: "Portland", coords: [-122.60, 45.59] },
  AUS: { name: "Austin-Bergstrom", city: "Austin", coords: [-97.67, 30.20] },
  HNL: { name: "Daniel K. Inouye", city: "Honolulu", coords: [-157.92, 21.32] },
  ANC: { name: "Ted Stevens Anchorage", city: "Anchorage", coords: [-149.99, 61.17] },
  
  // International - Europe
  LHR: { name: "Heathrow", city: "London", coords: [-0.46, 51.47] },
  CDG: { name: "Charles de Gaulle", city: "Paris", coords: [2.55, 49.01] },
  FRA: { name: "Frankfurt", city: "Frankfurt", coords: [8.57, 50.03] },
  AMS: { name: "Schiphol", city: "Amsterdam", coords: [4.76, 52.31] },
  MUC: { name: "Munich", city: "Munich", coords: [11.79, 48.35] },
  FCO: { name: "Fiumicino", city: "Rome", coords: [12.25, 41.80] },
  MAD: { name: "Adolfo Suárez", city: "Madrid", coords: [-3.57, 40.47] },
  BCN: { name: "El Prat", city: "Barcelona", coords: [2.08, 41.30] },
  ZRH: { name: "Zurich", city: "Zurich", coords: [8.55, 47.46] },
  DUB: { name: "Dublin", city: "Dublin", coords: [-6.27, 53.42] },
  EDI: { name: "Edinburgh", city: "Edinburgh", coords: [-3.37, 55.95] },
  LIS: { name: "Lisbon", city: "Lisbon", coords: [-9.13, 38.77] },
  
  // International - Asia Pacific
  NRT: { name: "Narita", city: "Tokyo", coords: [140.39, 35.76] },
  HND: { name: "Haneda", city: "Tokyo", coords: [139.78, 35.55] },
  ICN: { name: "Incheon", city: "Seoul", coords: [126.45, 37.46] },
  PEK: { name: "Beijing Capital", city: "Beijing", coords: [116.58, 40.08] },
  PVG: { name: "Pudong", city: "Shanghai", coords: [121.81, 31.14] },
  HKG: { name: "Hong Kong", city: "Hong Kong", coords: [113.91, 22.31] },
  SIN: { name: "Changi", city: "Singapore", coords: [103.99, 1.36] },
  SYD: { name: "Kingsford Smith", city: "Sydney", coords: [151.18, -33.95] },
  MEL: { name: "Melbourne", city: "Melbourne", coords: [144.84, -37.67] },
  DEL: { name: "Indira Gandhi", city: "New Delhi", coords: [77.10, 28.56] },
  BOM: { name: "Chhatrapati Shivaji", city: "Mumbai", coords: [72.87, 19.09] },
  
  // International - Americas
  MEX: { name: "Benito Juárez", city: "Mexico City", coords: [-99.07, 19.44] },
  CUN: { name: "Cancún International", city: "Cancún", coords: [-86.87, 21.04] },
  GRU: { name: "Guarulhos", city: "São Paulo", coords: [-46.47, -23.43] },
  EZE: { name: "Ezeiza", city: "Buenos Aires", coords: [-58.54, -34.82] },
  SCL: { name: "Arturo Merino", city: "Santiago", coords: [-70.79, -33.39] },
  BOG: { name: "El Dorado", city: "Bogotá", coords: [-74.15, 4.70] },
  LIM: { name: "Jorge Chávez", city: "Lima", coords: [-77.11, -12.02] },
  YYZ: { name: "Pearson", city: "Toronto", coords: [-79.63, 43.68] },
  YVR: { name: "Vancouver", city: "Vancouver", coords: [-123.18, 49.19] },
  YUL: { name: "Trudeau", city: "Montreal", coords: [-73.74, 45.47] },
  
  // International - Middle East & Africa
  DXB: { name: "Dubai International", city: "Dubai", coords: [55.36, 25.25] },
  TLV: { name: "Ben Gurion", city: "Tel Aviv", coords: [34.89, 32.01] },
  JNB: { name: "O.R. Tambo", city: "Johannesburg", coords: [28.23, -26.14] },
  CPT: { name: "Cape Town", city: "Cape Town", coords: [18.60, -33.97] },
};

// Get airport info with fallback for unknown codes
export const getAirport = (code) => {
  const upperCode = code?.toUpperCase?.() || code;
  return AIRPORTS[upperCode] || { 
    name: upperCode, 
    city: upperCode, 
    coords: [0, 0] 
  };
};
